export const TRAINING_ANSWER_MAX_LENGTH = 600;
export const SHORT_TALK_BOT_MAX_LENGTH = 4000;
export const SHORT_TALK_TOTAL_MAX_LENGTH = 64000;

export function isTrainingConversationWithinLimits(
  messages: ReadonlyArray<{ role: string; text: string }>,
  maxMessages: number,
  learnerMessage = '',
): boolean {
  if (
    learnerMessage.length > TRAINING_ANSWER_MAX_LENGTH ||
    messages.length > maxMessages
  ) {
    return false;
  }
  let total = learnerMessage.length;
  for (const message of messages) {
    const maxLength =
      message.role === 'bot'
        ? SHORT_TALK_BOT_MAX_LENGTH
        : TRAINING_ANSWER_MAX_LENGTH;
    total += message.text.length;
    if (
      message.text.length > maxLength ||
      total > SHORT_TALK_TOTAL_MAX_LENGTH
    ) {
      return false;
    }
  }
  return true;
}
